//navスクロール固定+アイコン非表示
document.addEventListener('DOMContentLoaded', () => {
  const nav = document.getElementById('menuNav');
  const target = document.querySelector('.main__contentarea'); // ← カクつき防止
  if (!nav) return;

  const navOffset = nav.getBoundingClientRect().top + window.scrollY;
  const navHeight = nav.offsetHeight;
  const isMobile = window.innerWidth <= 768;

  if (isMobile) return; // スマホはこの機能を無効化

  window.addEventListener('scroll', () => {
    if (window.scrollY >= navOffset) {
      if (!nav.classList.contains('is-fixed')) {
        nav.classList.add('is-fixed');
        if (target) target.style.marginTop = `${navHeight}px`;
      }
    } else {
      if (nav.classList.contains('is-fixed')) {
        nav.classList.remove('is-fixed');
        if (target) target.style.marginTop = '';
      }
    }
  });
});

//nav製品情報カテゴリ表示
// document.addEventListener('DOMContentLoaded', () => {
//   const toggleLinks = document.querySelectorAll('.toggle-link');

//   toggleLinks.forEach(link => {
//     link.addEventListener('click', (e) => {
//       e.preventDefault();
//       const targetId = link.getAttribute('data-target');
//       const target = document.getElementById(targetId);

//       if (target) {
//         target.classList.toggle('is-open');
//       }
//     });
//   });
// });

// KV吹き出しアニメ：ホバーで一時停止
document.addEventListener('DOMContentLoaded', () => {
  const popups = document.querySelectorAll('.popup');
  if (popups.length === 0) return; // ← popがない場合は動かさない

  let index = 0;
  let isPaused = false;

  // スマホならアニメーションを無効化
  const isMobile = window.innerWidth <= 768;
  if (isMobile) return;

  popups.forEach(popup => {
    popup.addEventListener('mouseenter', () => {
      isPaused = true;
    });
    popup.addEventListener('mouseleave', () => {
      isPaused = false;
    });
  });

  setInterval(() => {
    if (isPaused) return;

    popups.forEach(p => p.classList.remove('show'));
    popups[index].classList.add('show');
    index = (index + 1) % popups.length;
  }, 2500);
});


//製品を探す 検索表示切り替え
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.switching__tab li');
  const contents = document.querySelectorAll('.choice-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // タブ切替
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      // コンテンツ切替
      const target = tab.getAttribute('data-tab');
      contents.forEach(content => {
        content.classList.remove('is-shown');
        if (content.classList.contains(target)) {
          content.classList.add('is-shown');
        }
      });
    });
  });
});


//TOP specialスライダー

//  document.addEventListener('DOMContentLoaded', function () {
//    const glider = new Glider(document.querySelector('.glider'), {
//      slidesToShow: 3.2, // 1画面のバナー数
//      slidesToScroll: 1,
//      draggable: true,
//      dots: '.dots',
//      scrollLock: true,
//      rewind: true,
//      duration: 1.2 // スーッと滑らかに移動する時間（秒）
//    });

//  });

// ページ読み込み時に #アンカーがある場合の補正スクロール
document.addEventListener('DOMContentLoaded', () => {
  const windowWidth = window.innerWidth;

  // モバイル（768px以下）は処理しない
  if (windowWidth <= 768) return;

  const hash = location.hash;
  if (hash) {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
      const offset = 150; // PC用のオフセット（モバイルは無視されるので不要）

      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      setTimeout(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});

// ページ内リンク（クラス .anchor がついてるaタグだけ）
document.addEventListener('DOMContentLoaded', function() {
  const anchorLinks = document.querySelectorAll('a.anchor[href^="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const windowWidth = window.innerWidth;
        const offset = windowWidth > 768 ? 130 : 20; // 幅768より大きい場合：それ以外

        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});



// 汎用モーダル
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('simple-modal');
  const modalContent = document.getElementById('modal-content'); // テキストも画像も入れられる要素
  const triggers = document.querySelectorAll('.modal-trigger');
  const closeBtns = [modal.querySelector('.modal-close'), modal.querySelector('.modal-background')];

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const content = trigger.dataset.image || trigger.dataset.text;
      if (content) {
        if (trigger.dataset.image) {
          // 画像モーダルの場合
          modalContent.innerHTML = `<img src="${content}" alt="モーダル画像">`;
        } else if (trigger.dataset.text) {
          // テキストモーダルの場合
          modalContent.textContent = content;
        }
        modal.classList.add('is-active');
      }
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.classList.remove('is-active');
      modalContent.innerHTML = ''; // 内容クリア
    });
  });
});



if (location.pathname.startsWith('/biz/contact/')) {
  jQuery(document).ready(function($) {
    function toggleAddressField() {
      const isPostChecked = $('input[name="send_method[data][]"][value="郵送"]').prop('checked');

      if (isPostChecked) {
        $('#address-fields').slideDown();
        console.log("住所欄が表示されました");
        $('#address-fields').find('input, select').prop('disabled', false);
      } else {
        $('#address-fields').slideUp();
        console.log("住所欄が非表示になりました");
        $('#address-fields').find('input, select').prop('disabled', true);
      }
    }

    toggleAddressField();

    $(document).on('change', 'input[name="send_method[data][]"]', function() {
      toggleAddressField();
      console.log("チェックボックスの状態を監視します");
    });
  });
}


// menuNav toggle-content（#target-1）をスクロールで閉じる with debug logs
document.addEventListener('DOMContentLoaded', () => {
  const path = location.pathname;

  let nav = null;
  if (path.startsWith('/biz/')) {
    nav = document.getElementById('menuNav');
  } else if (path.startsWith('/global/')) {
    nav = document.querySelector('.main-nav');
  }

  if (!nav) return;

  const toggleLinks = nav.querySelectorAll('.toggle-link');

  toggleLinks.forEach(link => {
    const targetId = link.dataset.target;
    const target = document.getElementById(targetId);
    if (!target) return;

    let isOpen = false;
    let lastScroll = window.scrollY;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      target.classList.toggle('is-open');
      isOpen = target.classList.contains('is-open');
    });

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (isOpen && Math.abs(currentScroll - lastScroll) > 5) {
        target.classList.remove('is-open');
        isOpen = false;
      }
      lastScroll = currentScroll;
    }, { passive: true });
  });
});


// downloadページ専用アコーディオン（toggleのみ版）
document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.toggle-download');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault();

      const targetClass = toggle.dataset.target;
      const targets = document.querySelectorAll(`.toggle-download-content.${targetClass}`);
      if (!targets.length) return;

      const isOpen = targets[0].classList.contains('is-open');

      // すべて閉じる
      document.querySelectorAll('.toggle-download-content').forEach(content => content.classList.remove('is-open'));
      document.querySelectorAll('.toggle-download').forEach(t => {
        t.classList.remove('is-open');
        t.style.borderBottom = '1px solid #cdaf81';
      });

      // 自分を開く
      if (!isOpen) {
        toggle.classList.add('is-open');
        toggle.style.borderBottom = 'none';
        targets.forEach(t => t.classList.add('is-open'));
      }
    });
  });
});


//レイアウトから検索 ホバーテキスト表示
document.addEventListener('DOMContentLoaded', () => {
  const areas = document.querySelectorAll('map area');

  areas.forEach((area, index) => {
    const coords = area.coords.split(',').map(n => parseInt(n, 10));
    const parent = area.closest('.flame');

    if (parent && window.getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    // hover-area生成
    const hoverArea = document.createElement('div');
    hoverArea.className = 'hover-area';
    hoverArea.style.left = `${coords[0]}px`;
    hoverArea.style.top = `${coords[1]}px`;
    hoverArea.style.width = `${coords[2] - coords[0]}px`;
    hoverArea.style.height = `${coords[3] - coords[1]}px`;
    hoverArea.style.position = 'absolute';

    // aタグ生成
    const hoverLink = document.createElement('a');
    hoverLink.href = area.href;
    hoverLink.target = area.target || '_self';
    hoverLink.style.display = 'block';
    hoverLink.style.width = '100%';
    hoverLink.style.height = '100%';
    hoverLink.style.position = 'absolute';
    hoverLink.style.left = '0';
    hoverLink.style.top = '0';
    hoverLink.style.background = 'transparent';
    hoverLink.style.textDecoration = 'none';

    // span（テキスト）生成
    const hoverText = document.createElement('span');
    hoverText.className = `hover-text item${(index + 1).toString().padStart(2, '0')}`;
    hoverText.innerHTML = area.dataset.html;

    hoverArea.appendChild(hoverLink);
    hoverArea.appendChild(hoverText);
    parent.appendChild(hoverArea);
  });
});

